import React from 'react'
import './footer.css'

export const Footer = () => {
return (
<footer class="main-footer">
        <div class="auto-container">
            {/* <!--Widgets Section--> */}
            <div class="widgets-section">
                <div class="row clearfix">
                    {/* <!--  <div class="footer-column col-md-4 col-sm-6 col-xs-12">
        <div id="bunch_about_us-2"  class="footer-widget widget_bunch_about_us">      		
        <!--Footer Column--
        <div class="logo-widget">
        <div class="logo"> */}
        


    {/* <!-- <script src="https://platform.linkedin.com/in.js" type="text/javascript"> lang: en_US</script>
<script type="IN/FollowCompany" data-id="13247999" data-counter="bottom"></script>--
<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:6516636359938142208" height="380" width="400" frameborder="0" allowfullscreen="" class="e2"></iframe>
--


        </div>
        </div>
        </div>
         </div>--> */}
                    <div className="footer-column col-md-8 col-sm-6 col-xs-12">
                        <div id="pages-2" className="footer-widget widget_pages">

                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.0315340485977!2d77.62605331482203!3d12.969833990857033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae16a709de52a9%3A0x5e90e4aa3216397f!2sJobs+Territory!5e0!3m2!1sen!2sin!4v1552643304483" width="100%" height="350   " frameborder="0" style={{border: 0}} allowfullscreen=""></iframe>
                        </div>
                    </div>
                    <div className="footer-column col-md-4 col-sm-6 col-xs-12">
                        <div id="pages-2" className="footer-widget widget_pages c1">
                            <p style={{fontWeight:'bold',fontSize:'2em',marginBottom:'1vw'}}>Jobs Territory</p>
                            <div><i className="fa fa-map-marker-text " style={{fontSize:'1.5em',marginBottom:'1vw'}}>
                        
                                <span className="fontlink g1">1st floor,  110, Cambridge Rd,Ulsoor, Bengaluru, Karnataka 560008. </span></i></div>
                            <div><i className="fa fa-envelope " style={{fontSize:'1.5em',marginBottom:'1vw'}}>
                            
                                <span className="fontlink">careers@jobsterritory.com</span></i></div>
                            <div><i className="fa fa-phone "  style={{fontSize:'1.5em',marginBottom:'1vw'}}>
                                <span className="fontlink" >+91 9686116232</span> </i></div>
                        </div>
                    </div>
                    {/* <!--Footer Column--> */}
                </div>
            </div>
        </div>
        <div className="footer-bottom clearfix bottom2">
            <div className="pull-left">
                <div className="copyright">© Copyright  Jobs Territory 2022. All right reserved.</div>
            </div>
            <div className="pull-right">
                <div className="created">
                    <ul className="social-icon-two">
                        <li><a title="Facebook" href="https://www.facebook.com/jobsterritory/" target="_blank"><span className="fa fa-facebook"></span></a></li>
                        <li><a title="Linkedin" href="https://www.linkedin.com/company/jobs-territory" target="_blank"><span className="fa fa-linkedin"></span></a></li>
                        <li><a title="Instagram" href="https://www.instagram.com/jobsterritory/" target="_blank"><span className="fa fa-instagram"></span></a></li>
                    </ul>
                </div>
            </div>
        </div>
        </footer>
  )
}
